<div class="input-label-list">
  <div class="input-label-list-body">
    <div class="input-label-list-labels">
      <div *ngFor="let item of items" class="input-label-list-label">
        <p>{{ item.label | translate }}</p>
      </div>
    </div>

    <div class="input-label-list-separators">
      <div *ngFor="let item of items" class="input-label-list-separators">
        <p>{{ item.separator }}</p>
      </div>
    </div>

    <div class="input-label-list-inputs">
      <div *ngFor="let item of items; trackBy: trackByFn" class="input-label-list-input" [ngClass]="{ error: item.error }">
        <input [(ngModel)]="item.value" (input)="change.emit(items)" />
      </div>
    </div>
  </div>
</div>
